import { SearchResultsContentCardStyled } from "../ChoosePCPDrawerStyled";
import { SearchResultsContent } from "./SearchResultsContent";
import { SearchResultsSelectPCPDrawer } from "./SearchResultsSelectPCPDrawer";
import { BenefitPlanDto, PcpMembersDto } from "enrollment/queries/useBenefitPlansQuery/types";
import { AdditionalPlanElectionDataDto } from "../../../types";
import { PageContentQueryResponseDto } from "enrollment/queries/usePageContentQuery/types";

interface SearchResultsProps {
    providerData: any;
    electPlan?: () => void;
    setPcpElectionData: (data: AdditionalPlanElectionDataDto) => void;
    setPcpDrawerRequired: (value: boolean) => void;
    fromPlanDetails?: boolean;
    selectedDependentIds?: number[];
    openChooseProviderDrawer: boolean;
    setOpenChooseProviderDrawer: (value: boolean) => void;
    setShowPcpDrawer: (value: boolean) => void;
    plan?: BenefitPlanDto;
    hideDependentCheckboxWhenChecked: { [key: string]: boolean };
    setHideDependentCheckboxWhenChecked: (value: { [key: string]: boolean }) => void;
    selected: boolean;
    pcpMembers: PcpMembersDto;
    isEsignPlanRequired?: boolean;
    pageContent: PageContentQueryResponseDto | undefined;
}

export const SearchResults = ({ providerData,
    electPlan,
    setPcpElectionData,
    setPcpDrawerRequired,
    fromPlanDetails,
    selectedDependentIds,
    openChooseProviderDrawer,
    setOpenChooseProviderDrawer,
    setShowPcpDrawer,
    plan,
    hideDependentCheckboxWhenChecked,
    setHideDependentCheckboxWhenChecked,
    selected,
    pcpMembers,
    isEsignPlanRequired,
    pageContent }: SearchResultsProps) => {

    return (
        <SearchResultsContentCardStyled data-testid="search-provider-content">
            {providerData?.providers?.map((providerItem: any, index: any) => {

                return (
                    <div key={index}>
                        <SearchResultsContent providerItem={providerItem} index={`dental-pcp-${index}`} />
                        <SearchResultsSelectPCPDrawer
                            providerItem={providerItem}
                            index={index}
                            electPlan={electPlan}
                            setPcpElectionData={setPcpElectionData}
                            setPcpDrawerRequired={setPcpDrawerRequired}
                            fromPlanDetails={fromPlanDetails}
                            selectedDependentIds={selectedDependentIds}
                            openChooseProviderDrawer={openChooseProviderDrawer}
                            setOpenChooseProviderDrawer={setOpenChooseProviderDrawer}
                            setShowPcpDrawer={setShowPcpDrawer}
                            plan={plan}
                            hideDependentCheckboxWhenChecked={hideDependentCheckboxWhenChecked}
                            setHideDependentCheckboxWhenChecked={setHideDependentCheckboxWhenChecked}
                            selected={selected}
                            pcpMembers={pcpMembers}
                            isEsignPlanRequired={isEsignPlanRequired} 
                            pageContent={pageContent} />
                        <hr className="mt-3 mb-4 ml-1" />
                    </div>
                );
            })}
        </SearchResultsContentCardStyled>
    );
};